import React from "react";
import { IonContent, IonModal } from "@ionic/react";

type Props = {
  visible: boolean;
  dismiss: () => void;
  copy: () => void;
};

const SummaryOfWorkErrorModal: React.FC<Props> = (props) => {
  return (
    <IonModal
      id="summary-of-work-error-modal"
      isOpen={props.visible}
      backdropDismiss={true}
      canDismiss={true}
      onDidDismiss={() => props.dismiss()}
      className="fullscreen"
    >
      <IonContent>
        <div className="flex flex-col justify-between h-full">
          <div className="mt-4 px-4">
            <div className="text-[17px] font-bold leading-[1.41] tracking-default text-center text-grey-90">
              {"Error"}
            </div>
            <div className="mt-[4px] text-[15px] leading-[1.33] tracking-[-0.3px] text-center text-grey-90">
              {"An error occurred when saving your summary of work. Please try again later."}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="border-t border-t-grey-30">
              <button
                className="w-full h-[48px]"
                onClick={() => props.copy()}
              >
                <div className="text-[16px] font-semibold leading-default tracking-default text-center text-cta-blue">
                  {"Copy Summary of Work"}
                </div>
              </button>
            </div>
            <div className="border-t border-t-grey-30">
              <button
                className="w-full h-[48px]"
                onClick={() => props.dismiss()}
              >
                <div className="text-[16px] leading-default tracking-default text-center text-cta-blue ">
                  {"Dismiss"}
                </div>
              </button>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default SummaryOfWorkErrorModal;
